import { render } from "./contentInput.vue?vue&type=template&id=37d741f0"
import script from "./contentInput.vue?vue&type=script&lang=js"
export * from "./contentInput.vue?vue&type=script&lang=js"

import exportComponent from "/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__